"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Show = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const loader_1 = require("@festival/component/loader");
const not_found_1 = require("@festival/page/not-found");
const image_media_1 = require("@festival/component/image-media");
const react_helmet_1 = require("react-helmet");
const list_1 = require("@festival/tag/list");
const activity_link_1 = require("@festival/guest/activity-link");
const reactstrap_1 = require("reactstrap");
const react_share_1 = require("react-share");
const version_toggler_1 = require("@festival/versionable/version-toggler");
const striptags = require("striptags");
class Show extends React.Component {
    render() {
        const { slug } = this.props.match.params;
        const { guestStore, routeManager, activityStore, pageConfigurationStore } = this.props;
        if (!slug) {
            return React.createElement(not_found_1.default, null);
        }
        if (!guestStore || !routeManager || !activityStore || !pageConfigurationStore) {
            return null;
        }
        const guest = guestStore.get(slug);
        if ((!guest && guestStore.guests.length === 0) || guest && guest.statusLoader && guest.statusLoader.status === 'pending') {
            return (React.createElement(loader_1.default, null));
        }
        if (!guest || !guest.complete || (guest.statusLoader && guest.statusLoader.status === 'error')) {
            return React.createElement(not_found_1.default, null);
        }
        if (guest.active.slug !== slug) {
            return React.createElement(react_router_dom_1.Redirect, { to: routeManager.generate('guest-show', { params: { slug: guest.active.slug } }) });
        }
        const guestComplete = guest;
        const participations = activityStore.getParticipationsOf(guest.uuid);
        const configuration = pageConfigurationStore.get('guests');
        if (!configuration) {
            return null;
        }
        if (!configuration.complete) {
            return React.createElement(loader_1.default, null);
        }
        const configurationComplete = configuration;
        if (!configurationComplete.details) {
            return null;
        }
        return React.createElement(React.Fragment, null,
            this.renderMeta(guestComplete, routeManager, configurationComplete),
            this.renderContent(guestComplete, participations, routeManager, configurationComplete));
    }
    renderMeta(guest, routeManager, configuration) {
        const title = guest.active.name + (configuration.details ? ' - ' + configuration.details.showTitle : '');
        const description = (striptags(guest.active.biography)).substr(0, 160) + '...';
        const url = routeManager.root + this.props.location.pathname;
        const imageUrl = guest.active.media['sticker'] ? guest.active.media['sticker']['large'] : '';
        return (React.createElement(react_helmet_1.Helmet, null,
            React.createElement("title", null, title),
            React.createElement("meta", { name: "description", content: description }),
            React.createElement("meta", { name: "og:title", content: title }),
            React.createElement("meta", { name: "og:type", content: "article" }),
            React.createElement("meta", { name: "og:url", content: url }),
            React.createElement("meta", { name: "og:image", content: imageUrl }),
            React.createElement("meta", { name: "og:description", content: description }),
            React.createElement("meta", { property: "og:locale", content: "fr_FR" })));
    }
    renderContent(guest, participations, routeManager, configuration) {
        return (React.createElement("div", null,
            React.createElement(version_toggler_1.default, { container: guest, className: "position-absolute", style: { top: 0 } }),
            React.createElement(image_media_1.default, { media: guest.active.media, name: "cover", version: "large", className: "card-img-top", alt: guest.active.altCover }),
            React.createElement("h1", null,
                guest.active.guestOfHonor && (React.createElement("i", { className: "mdi mdi-star" })),
                guest.active.name),
            React.createElement(list_1.default, { type: "guest", codes: guest.active.tags, root: routeManager.generate('guests') }),
            guest.active.externalLink && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "mdi mdi-link mr-2" }),
                React.createElement(react_intl_1.FormattedMessage, { id: "guest.show.external_link" }),
                React.createElement("a", { href: guest.active.externalLink, className: "external ml-2", target: "_blank", rel: "noreferrer" }, guest.active.externalLink))),
            React.createElement("div", { className: "biography", dangerouslySetInnerHTML: { __html: guest.active.biography } }),
            React.createElement("div", { className: "social-share" },
                React.createElement("h2", { className: "text-uppercase text-primary text-center mt-2" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "guest.show.social-share" })),
                React.createElement("div", { className: "d-flex justify-content-around flex-lg-column justify-content-sm-start" },
                    React.createElement(reactstrap_1.Button, { tag: react_share_1.TwitterShareButton, resetButtonStyle: false, url: (this.props.routeManager ? this.props.routeManager.root : '') + this.props.location.pathname, size: "sm", className: "btn-twitter text-nowrap mr-2 mr-lg-0 mb-lg-2" },
                        React.createElement("i", { className: "mdi mdi-twitter mr-2" }),
                        React.createElement(react_intl_1.FormattedMessage, { id: "guest.show.social-share.twitter" })),
                    React.createElement(reactstrap_1.Button, { tag: react_share_1.FacebookShareButton, resetButtonStyle: false, url: (this.props.routeManager ? this.props.routeManager.root : '') + this.props.location.pathname, size: "sm", className: "btn-facebook text-nowrap" },
                        React.createElement("i", { className: "mdi mdi-facebook mr-2" }),
                        React.createElement(react_intl_1.FormattedMessage, { id: "guest.show.social-share.facebook" })))),
            participations.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("h2", null,
                    React.createElement(react_intl_1.FormattedMessage, { id: "guest.show.participations" })),
                React.createElement(reactstrap_1.Row, { className: "row-cols-1 row-cols-md-2 row-cols-lg-3" }, participations.map((activity, index) => (React.createElement(reactstrap_1.Col, { key: index },
                    React.createElement(activity_link_1.default, { activity: activity })))))))));
    }
}
exports.Show = Show;
exports.default = react_router_dom_1.withRouter(mobx_react_1.inject('routeManager', 'guestStore', 'activityStore', 'pageConfigurationStore')(mobx_react_1.observer(Show)));
